import Link from "next/link";

import { routes } from "src/shared/routes";
import { createJsxLink } from "src/utils/create-jsx-link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Student Football Ticket",
    description:
      "Register your student ticket package and use My Group to guarantee tickets close to your group. Student seating is allocated based on the lowest rank in the group. Class ranks used are the class ranks as of the end of Spring Semester 2026.",
    authRedirectPage: routes.my_group,
    buttonLabel: "Register Your Account",
    buttonVariant: "contained",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "Tickets will be delivered to your Ohio State Account Manager at the beginning of the season.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Yes, you can view your upcoming events to see all games that you are eligible for a ticket to.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will be notified tickets are available the day before the game via text message.",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations will be in the student section.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer: "Tickets are not eligible for transfer or re-sale.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please contact the Ohio State University Box Office for any assistance you may require.",
  },
  {
    question: "Can I link tickets with other students?",
    answer: (
      <>
        Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "buckeyes_texasaway" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        next to or close enough to hand a drink to one another for the game. You
        will need to ensure your group is created and all members have joined by
        July 25 2026.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer: "Guest tickets are not available for purchase.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
];

export const TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the{" "}
      {createJsxLink(
        "Terms & Conditions",
        "https://www.attend.tech/terms-of-use"
      )}{" "}
      and{" "}
      {createJsxLink(
        "Privacy Policy",
        "https://www.attend.tech/privacy-policy"
      )}
      .
    </>
  );
};
